exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stars {\n  margin: 0; }\n  .stars .fa-star {\n    font-size: 16px; }\n  .stars .active {\n    color: #FF8600; }\n  .stars .deactive {\n    color: #828282; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/star-rating/star-rating.component.scss
// module id = ../../../../../src/app/shared/star-rating/star-rating.component.scss
// module chunks = main